import { axiosInstance } from "../../axiosConfig";
import devLogInstance, { prodLogInstance } from "../../loggerConfig";

export default async function getConsentPageData() {
  try {
    const { data } = await axiosInstance.get("/get_consent_page_data");
    devLogInstance.log(`Response after getting the consent page data:`);
    devLogInstance.log(data);
    return data;
  } catch (err) {
    prodLogInstance.error(err);
    throw err;
  }
}
